import {
  ChakraTable,
  ChakraText as Text,
  ChakraTbody as Tbody,
  ChakraTd as Td,
  ChakraTh as Th,
  ChakraThead as Thead,
  ChakraTr as Tr,
} from "@airhelp/react-ui-components";
import type {
  OurFeesCompensationTableAdapterProps,
  CompensationListProps,
} from "modules/storyblok/adapters/OurFeesCompensationTable";
import { storyblokEditable } from "@storyblok/react";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { OurCompensationTableProps } from "./OurCompensationTable.d";
import { calculateAmount } from "./utils";
import tableStyles from "./styles";
import { STANDARD_FEE, STANDARD_COMPENSATION, LEGAL_FEE, LEGAL_COMPENSATION } from "./config";

const STANDARD_TABLE = "standardTable";

const FeeTable = ({ type = STANDARD_TABLE, blok }: OurCompensationTableProps) => {
  const {
    standardHeadingText,
    standardHeadingDescription,
    legalHeadingText,
    legalHeadingDescription,
    byAirlineHeadingText,
    ourFeeText,
    youWillRecieveText,
    compensationList,
  } = blok;

  const isStandardTable = type === STANDARD_TABLE;
  const tableHeading = isStandardTable ? standardHeadingText : legalHeadingText;
  const tableDescription = isStandardTable ? standardHeadingDescription : legalHeadingDescription;

  return (
    <ChakraTable sx={tableStyles} {...storyblokEditable(blok)}>
      <Thead>
        <Tr>
          <Th colSpan={3} bg="primary.100" textTransform="none" textAlign="left" py={2} px={4}>
            <Text fontSize="xl" fontWeight="semibold">
              {tableHeading}
            </Text>
            <Text fontSize="sm" color="greyscale.600">
              {tableDescription}
            </Text>
          </Th>
        </Tr>
        <Tr bg="greyscale.200">
          <Th fontSize="10px" color="greyscale.500" textAlign="right" py={2} px={4}>
            {byAirlineHeadingText}
          </Th>
          <Th fontSize="10px" color="greyscale.500" textAlign="right">
            {ourFeeText}
          </Th>
          <Th fontSize="10px" color="greyscale.500" textAlign="right">
            {youWillRecieveText}
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        {compensationList?.map((compensation: CompensationListProps) => {
          const feeType = isStandardTable ? STANDARD_FEE : LEGAL_FEE;
          const compensationType = isStandardTable ? STANDARD_COMPENSATION : LEGAL_COMPENSATION;

          return (
            <Tr key={compensation._uid}>
              <Td whiteSpace="nowrap">{calculateAmount(compensation.compensationAmount)}</Td>
              <Td whiteSpace="nowrap">{calculateAmount(compensation.compensationAmount, feeType)}</Td>
              <Td whiteSpace="nowrap" fontWeight="semibold">
                {calculateAmount(compensation.compensationAmount, compensationType)}
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </ChakraTable>
  );
};

const OurFeesCompensationTableMobile = ({ blok }: ReactStoryblokComponent<OurFeesCompensationTableAdapterProps>) => (
  <>
    <FeeTable blok={blok} />
    <FeeTable blok={blok} type="legalTable" />
  </>
);

export default OurFeesCompensationTableMobile;
